import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const renderApp = (Component) => {
  const customRootElement = document.getElementById('job-listings-root');

  if (customRootElement) {
    // Render to the custom root element
    const customRoot = ReactDOM.createRoot(customRootElement);
    customRoot.render(<Component />);
  } else {
    // Fallback: Render to the default "root" element
    const defaultRootElement = document.getElementById('root');

    if (defaultRootElement) {
      const defaultRoot = ReactDOM.createRoot(defaultRootElement);
      defaultRoot.render(<Component />);
    } else {
      console.error('No valid root element found to render the App.');
    }
  }
};

// Call the renderApp function to render the App
renderApp(App);
